import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import * as inventoryExportActionCreators from '@atom/actions/inventoryExportActions';
import { View } from '@atom/components/inventoryExport/InventoryExportContext';
import { useNavigation } from '@atom/hooks/useNavigation';
import layout from '@atom/styles/layout';
import { RootState } from '@atom/types/store';

import InventoryCustomExportsTable from './InventoryCustomExportsTable';
import InventoryExportList from './InventoryExportList';
import InventoryExportPortalHeader from './InventoryExportPortalHeader';
import InventoryExportSidebar from './InventoryExportSidebar';

import classes from './inventoryExport.module.css';

const styles = {
  rightPane: {
    display: 'flex',
    flexDirection: 'column',
    width: `calc(100% - ${layout.sidePaneWidth})`,
    height: `calc(100vh - ${layout.fixedHeaderOffset})`,
    marginTop: '6.875rem',
  },
};

const InventoryExportPortal = () => {
  const [, { navigate }] = useNavigation();
  const dispatch = useDispatch();
  const loading = useSelector(
    (rootState: RootState) => rootState.loading.loadingExportTemplates,
  );
  const exportTemplates = useSelector(
    (rootState: RootState) => rootState.exportTemplates,
  );
  const loadingExportTemplateCreation = useSelector(
    (rootState: RootState) => rootState.loading.loadingExportTemplateCreation,
  );

  const [activeView, setActiveView] = useState<View>(View.DATA_EXPORTS);

  useEffect(() => {
    dispatch(
      inventoryExportActionCreators.requestExportTemplates({
        isPublished: 'true,false',
      }),
    );
  }, []);

  const getContent = () => {
    const views = {
      [View.DATA_EXPORTS]: (
        <InventoryExportList
          exportTemplates={exportTemplates}
          loading={loading}
        />
      ),
      [View.CUSTOM_EXPORTS]: <InventoryCustomExportsTable />,
    };

    return views[activeView];
  };

  const navigateBack = (): void => {
    navigate('/inventory');
  };

  return (
    <div className={classes.portalWrapper}>
      <InventoryExportPortalHeader
        navigateBack={navigateBack}
        loading={loadingExportTemplateCreation}
      />
      <div className={classes.leftPane}>
        <InventoryExportSidebar
          activeView={activeView}
          setActiveView={setActiveView}
        />
      </div>
      <div style={styles.rightPane}>{getContent()}</div>
    </div>
  );
};

export default InventoryExportPortal;
